import { createFileRoute } from "@tanstack/react-router";

import {
  ADD_BACKUP_METHOD_MODAL,
  paymentMethodsSearchSchema,
  PaymentMethodsTab,
} from "@/features/billing";

export const Route = createFileRoute(
  "/_auth/_app-shell/billing/$projectId/payment-methods",
)({
  component: RouteComponent,
  validateSearch: paymentMethodsSearchSchema,
});

function RouteComponent() {
  const { projectId } = Route.useParams();
  const { modal } = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <PaymentMethodsTab
      isAddBackupOpen={modal === ADD_BACKUP_METHOD_MODAL}
      onAddBackupOpenChange={(isOpen) =>
        navigate({
          search: (prev) => ({
            ...prev,
            modal: isOpen ? ADD_BACKUP_METHOD_MODAL : undefined,
          }),
        })
      }
      projectId={Number(projectId)}
    />
  );
}
